//方法名称 缓存key 
export const api={
	//'sysConfig':{'using':'common','name':'sysConfig'},
	//'apiConfig':{'using':'common','name':'apiConfig'},
	// 'getDicts':{'using':'common','name':'dicts'},	
	'getProvinces':{'using':'common','name':'provinces'},
	'getCitys':{'using':'common','name':'citys'},
	'getDistricts':{'using':'common','name':'districts'},
	
	// 'getUser':{'using':'login','name':'userInfo'},
	
	'getWarehouseInfo':{'using':'order','name':'warehouseInfo'},
	'getProductInfo':{'using':'order','name':'productInfo'},
	'getCDNProductInfo':{'using':'order','name':'productInfo'},
	 'getNoticeInfo':{'using':'order','name':'noticeInfo'},
	// 'getProductStock':{'using':'login','name':'productStockInfo'},
	
//	'accountLogin':'loginer',
//	'getCartInfo':'cartInfo',
//	'getNoticeInfo':'noticeInfo',
//	'getWarehouseInfo':'warehouseInfo',
//	'getAddressKey':'addresskey'
	'getPageConfig':{'using':'common','name':'pageConfig'},
	'getPageConfigDetail':{'using':'common','name':'pageConfigDetail'},
	'getMenuItems':{'using':'common','name':'navMenus'}
}

export const apiKey={
	'productInfo':'Cache_ProductKey',
	'noticeInfo':'Cache_NoticeKey',
	'warehouseInfo':'Cache_WarehouseKey',
	'pageConfig':'Cache_PageConfigKey',
	'pageConfigDetail':'Cache_PageDetailKey',
	'navMenus':'WS_CacheKey_GetMenuDataConfig',
	'provinces':'Cache_ProvinceKey',
	'citys':'Cache_CityKey',
	'districts':'Cache_CountyKey'
}

